import { render } from "./App.vue?vue&type=template&id=f1bcab30&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f1bcab30&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bcab30"]])

export default __exports__